import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';
import $ from 'jquery';

import { showModal } from '../../actions';

import { getSetting } from '../../helpers/Settings';

const DashboardWidgetSuggested = ({ openModal }) => {
  const [buttonSize, setButtonSize] = useState('big');
  const intl = useIntl();

  const handleChangeButtons = useCallback(() => {
    let minWidth = $('.dashboard-section-suggestion-wrapper').width();
    $('.dashboard-section-suggestion').each(function () {
      minWidth = Math.min(minWidth, $(this).width());
    });
    setButtonSize(minWidth < 200 ? 'small' : 'big');
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(handleChangeButtons);
    const suggestions = document.querySelector('.dashboard-section-suggestion-wrapper');

    resizeObserver.observe(suggestions);

    return () => {
      resizeObserver.unobserve(suggestions);
    };
  }, [handleChangeButtons]);

  let suggestions = [
    {
      title: intl.formatMessage({ defaultMessage: 'Annotations' }),
      icon: 'fal fa-comment-plus',
      rotate: '-20deg',
      wiki: 'https://help.stockpress.co/en/articles/5937476-leaving-comments-and-annotations-on-images-videos-and-pdfs',
      video: 'https://player.vimeo.com/video/1063863507?h=79b83d38ec&badge=0&byline=0&title=0',
    },
    {
      title: intl.formatMessage({ defaultMessage: 'Facial Recognition' }),
      icon: 'fal fa-user-viewfinder',
      rotate: '-20deg',
      wiki: 'https://help.stockpress.co/en/articles/12415334-facial-recognition',
      video: 'https://player.vimeo.com/video/1124983345?h=dc59c0564d&badge=0&byline=0&title=0',
    },
    {
      title: intl.formatMessage({ defaultMessage: 'Smart Collections' }),
      icon: 'fal fa-bolt',
      wiki: 'https://help.stockpress.co/en/articles/11757271-smart-collections',
      video: 'https://player.vimeo.com/video/1101340116?h=5e3805a4e3&badge=0&byline=0&title=0',
    },
    {
      title: intl.formatMessage({ defaultMessage: 'Tag Categories' }),
      icon: 'fal fa-tags',
      wiki: 'https://help.stockpress.co/en/articles/5937851-creating-and-managing-custom-categories',
      video: 'https://player.vimeo.com/video/1063863653?h=daa4c82a29&badge=0&byline=0&title=0',
    },
    {
      title: intl.formatMessage({ defaultMessage: 'Image editor' }),
      icon: 'fal fa-crop',
      rotate: '-20deg',
      wiki: 'https://help.stockpress.co/en/articles/9341551-crop-assets-with-our-image-editor',
      video: 'https://player.vimeo.com/video/1063863519?h=2c58d8864a&badge=0&byline=0&title=0',
    },
  ];

  if (getSetting('cs1')) {
    suggestions = [
      {
        title: intl.formatMessage({ defaultMessage: 'Creating My Collections' }),
        icon: 'fal fa-bookmark',
        rotate: '-20deg',
        video: 'https://player.vimeo.com/video/1073788168?h=806dcda6ef&badge=0&byline=0&title=0',
      },
      {
        title: intl.formatMessage({ defaultMessage: 'Requesting files' }),
        icon: 'fal fa-cart-arrow-down',
        rotate: '-20deg',
        video: 'https://player.vimeo.com/video/1073788225?h=4c927ae8dd&badge=0&byline=0&title=0',
      },
      {
        title: intl.formatMessage({ defaultMessage: 'Search and filter' }),
        icon: 'fal fa-search',
        rotate: '-20deg',
        video: 'https://player.vimeo.com/video/1073788208?h=7a15cc1833&badge=0&byline=0&title=0',
      },
      {
        title: intl.formatMessage({ defaultMessage: 'Pinning searches' }),
        icon: 'fal fa-thumbtack',
        rotate: '-20deg',
        video: 'https://player.vimeo.com/video/1073788193?h=d3a6e46067&badge=0&byline=0&title=0',
      },
      {
        title: intl.formatMessage({ defaultMessage: 'Personalizing dashboard' }),
        icon: 'fal fa-tachometer-alt-fast',
        rotate: '-20deg',
        video: 'https://player.vimeo.com/video/1073938453?h=87af52c340&badge=0&byline=0&title=0',
      },
    ];
  }

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <h3>{intl.formatMessage({ defaultMessage: 'Suggested for you' })}</h3>
      </div>
      <div className="dashboard-section-content">
        <div className="dashboard-section-suggestion-wrapper">
          {suggestions.map(s => (
            <div className="dashboard-section-suggestion" key={s.title}>
              <div className="dashboard-section-suggestion-title">
                <div />
                <span>
                  {s.video && (
                    getSetting('cs1') ? (
                      <i className="far fa-circle-play mr-1" />
                    ) : (
                      <i className="far fa-circle-info mr-1" />
                    )
                  )}
                  {s.title}
                </span>
                <div className="dashboard-section-suggestion-title-buttons">
                  {s.wiki && (
                    <Button color="link" size="sm" tag="a" href={s.wiki} target="_blank">
                      <i className="far fa-book mr-1" />
                      {buttonSize === 'big' ? (
                        intl.formatMessage({ defaultMessage: 'Learn more' })
                      ) : (
                        intl.formatMessage({ defaultMessage: 'Learn' })
                      )}
                    </Button>
                  )}
                  {s.video && (
                    <Button
                      size="sm"
                      onClick={() => openModal(s.video, s.title)}
                    >
                      <i className="far fa-play mr-1" />
                      {buttonSize === 'big' ? (
                        intl.formatMessage({ defaultMessage: 'Watch video' })
                      ) : (
                        intl.formatMessage({ defaultMessage: 'Watch' })
                      )}
                    </Button>
                  )}
                </div>
              </div>
              <span className="dashboard-section-suggestion-icon">
                <i
                  className={`${s.icon} fa-rotate-by`}
                  style={{ '--fa-rotate-angle': s.rotate ? `${s.rotate}` : '0deg' }}
                />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  openModal: (url, title) => {
    dispatch(showModal('VideoPlayerModal', {
      className: 'modal-video-player',
      url,
      title,
      backdrop: true,
    }));
  },
});

DashboardWidgetSuggested.propTypes = {
  openModal: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(DashboardWidgetSuggested);
